module.exports = __webpack_public_path__ + "img/7.8472e178.png";